import React from 'react';

export function Spinner(props) {
	let classNameProp = props.className ? props.className : "";
	return (
		<div className={`loader ${classNameProp}`}>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	);
}